export default __webpack_public_path__ + "static/media/fummiNcake_w640.8500ea6f.jpeg";